import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

import LocationOnIcon from '@material-ui/icons/LocationOn';
import { Alert, AlertTitle } from '@material-ui/lab';

import CustomTabs from 'components/CustomTabs/CustomTabs.js';

import Horario from 'components/horario/horario.component';
import { useDispatch, useSelector } from 'react-redux';
import { getHorariosOficina } from 'redux/actions/aOficinas';
import Loading from 'components/Loading';

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    width: '100%',
    backgroundColor: theme.palette.background.paper,
  },
}));

const HorarioOficinaSecretaria = ({ oficinas, doctor_id = '' }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { data, isLoading, hasError } = useSelector(state => state.horariosOficinas);



  return (
    <Loading title="Cargando..." loading={isLoading}>
      <div className={classes.root}>
        {hasError && (
          <Alert severity={`Error`}>
            <AlertTitle>{'Error'}</AlertTitle>
            {hasError}
          </Alert>
        )}
        {data && (
          <CustomTabs
            title="Oficinas:"
            headerColor="primary"
            tabs={oficinas.map((oficina, i) => ({
              tabName: oficina.nombre,
              tabIcon: LocationOnIcon,
              tabContent: (
                <Horario
                  doctor_id={doctor_id}
                  key={`oficina${i}`}
                  oficina_id={oficina.id}
                  tiempoConsulta={oficina.tiempo_por_cliente_minutos}
                  horarios={data.filter(horario => horario.oficina_id === oficina.id)}
                  getHorariosOficina={() => dispatch(getHorariosOficina())}
                />
              ),
            }))}
          />
        )}
      </div>
    </Loading>
  );
};

export default HorarioOficinaSecretaria;
